<template>
  <div>
    <el-tabs type="border-card" class="fullHeight" @tab-click="clickTab">
      <el-tab-pane class="paddingBody content" :label="$t('Tareas')">
        <center v-if="hidden === false">
          <el-alert type="info">
            <el-progress
              :status="step_percentage === 100 ? 'success' : null"
              :percentage="step_percentage"
              style="margin-bottom: 5px"
            ></el-progress>
            <small style="font-size: 15px">{{ step_loading_txt }}</small>
          </el-alert>
          <br /><br />
        </center>
        <center v-if="loadingAllDataRequired">
          <br />
          <br />
          <Circle9 style="margin-bottom: 8px"></Circle9>
          <small>Cargando Datos ...</small>
          <br />
          <br />
        </center>
        <el-row v-else>
          <el-col :md="24">
            <el-button
              v-if="canSendToApproval() && !$store.getters.user.readonly"
              size="small"
              type="info"
              v-loading.fullscreen.lock="isLoading"
              @click="verificarMA()"
            >
              <b>{{ $t("Enviar a Revisión") }}</b>
            </el-button>

            <el-button
              v-if="!$store.getters.user.readonly"
              size="small"
              :class="{
                intermitente:
                  contract !== null &&
                  inventory !== null &&
                  Object.keys(inventory).length === 0,
              }"
              style="margin-right: 20px; color: white !important"
              @click="handleAddTask()"
              type="primary"
              icon="el-icon-plus"
            >
              <b>Agregar tarea</b>
            </el-button>
          </el-col>

          <el-col
            v-if="
              contract !== null &&
              inventory !== null &&
              Object.keys(inventory).length === 0
            "
            :md="24"
            style="padding-left: 53px"
          >
            <br />
            <img src="../../assets/flecha-hacia-arriba.png" width="30" />
          </el-col>

          <el-col :md="24">
            <br />
            <el-alert
              style="border: 1px solid gray"
              v-if="
                contract !== null &&
                inventory !== null &&
                Object.keys(inventory).length === 0
              "
              type="info"
              show-icon
              :closable="false"
            >
              <template>
                <div style="color: black; padding-left: 10px">
                  <b>INSTRUCCIONES PARA CREAR SU INVENTARIO DE RIESGOS</b>
                  <p>
                    Para comenzar a crear su Inventario de Riesgos en primera
                    instancia debe oprimir el botón <b>"Agregar Tarea"</b>,
                    luego debe asignar un nombre a la tarea y posteriormente
                    agregar los riesgos que usted estime necesarios. Recuerde
                    que puede utilizar riesgos estandarizados los cuales
                    <b>no requieren de una evaluación para aprobarse</b>, si el
                    riesgo estandarizado no se adapta a sus necesidades o
                    necesita añadir uno diferente a los que se encuentran en el
                    listado usted puede realizarlo creando un riesgo
                    personalizado y así añadir con mayor detalle sus
                    especificaciones, para la aprobación de un riesgo de este
                    tipo
                    <b>se requiere la evaluación de diferentes usuarios</b>,
                    estos dependerán del nivel MFL de su riesgo.
                  </p>
                </div>
              </template>
            </el-alert>
            <el-alert
              style="border: 1px solid orange"
              v-if="
                !haveEnvironmentalRisks &&
                contract !== null &&
                inventory !== null &&
                Object.keys(inventory).length !== 0
              "
              type="warning"
              show-icon
              :closable="false"
            >
              <template>
                <div style="padding-left: 10px; color: black">
                  <b
                    >Advertencia: La plataforma detecto que en la actualidad su
                    inventario de riesgos no presenta riesgos o aspectos
                    medioambientales.</b
                  >
                  <p>
                    Esto quiere decir, que mientras su inventario no cuente con
                    riesgos o aspectos medioambientales, el inventario no podrá
                    ser enviado a fase de “Revisión”. Se recomienda incorporar
                    los riesgos mencionados si desea continuar con el proceso de
                    aprobación de su inventario en plataforma.
                  </p>
                </div>
              </template>
            </el-alert>
            <div
              v-if="
                !haveEnvironmentalRisks &&
                contract !== null &&
                inventory !== null &&
                Object.keys(inventory).length !== 0 &&
                validContinueEdit() === false
              "
            >
              <br />
              <span style="font-size: 14px"
                ><b>Formulario inventario sin riesgos medioambientales</b></span
              >
              <el-collapse style="margin-top: 13px">
                <el-collapse-item name="1">
                  <template slot="title">
                    <span style="font-size: 14px"
                      >Para visualizar el formulario contestado de inventarios
                      sin riesgos medioambientales haga clic aquí
                      <i
                        style="margin-left: 10px"
                        class="el-icon-caret-bottom"
                      ></i
                    ></span>
                  </template>
                  <table
                    style="width: 100%; margin-top: 10px"
                    border="1px"
                    cellspacing="0px"
                  >
                    <tr>
                      <td style="padding: 10px">¿Ustedes conducen?</td>
                      <td style="text-align: center">
                        <el-radio disabled v-model="preguntas['1']" label="SI"
                          >SI</el-radio
                        >
                        <el-radio disabled v-model="preguntas['1']" label="NO"
                          >NO</el-radio
                        >
                      </td>
                    </tr>
                    <tr v-if="preguntas['1'] === 'SI'">
                      <td colspan="2" style="padding: 10px">
                        <span style="color: red">
                          Entonces su aspecto es la conducción o la camioneta,
                          el incidente falla de sistema hidráulico o rotura de
                          estanque combustible o aumento en gases de combustión,
                          como consecuencia contaminación de suelo, alteración
                          de la calidad del aire.</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 10px">
                        ¿Usted tiene instalación de faena o estará en oficinas
                        de Spence?
                      </td>
                      <td style="text-align: center">
                        <el-radio disabled v-model="preguntas['2']" label="SI"
                          >SI</el-radio
                        >
                        <el-radio disabled v-model="preguntas['2']" label="NO"
                          >NO</el-radio
                        >
                      </td>
                    </tr>
                    <tr v-if="preguntas['2'] === 'SI'">
                      <td colspan="2" style="padding: 10px">
                        <span style="color: red"
                          >Entonces su aspecto el trabajo administrativo,
                          incidente mal uso, pérdidas o derroche de uso de agua
                          o recurso hídrico, consecuencia agotamiento de recurso
                          natural / incidente mal uso de energía eléctrica,
                          consecuencia agotamiento de recurso, aumento gases
                          efecto invernadero.</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 10px">
                        ¿Usted comerá algo tomará agua?
                      </td>
                      <td style="text-align: center">
                        <el-radio disabled v-model="preguntas['3']" label="SI"
                          >SI</el-radio
                        >
                        <el-radio disabled v-model="preguntas['3']" label="NO"
                          >NO</el-radio
                        >
                      </td>
                    </tr>
                    <tr v-if="preguntas['3'] === 'SI'">
                      <td colspan="2" style="padding: 10px">
                        <span style="color: red"
                          >Entonces sí o sí va a tener generación de residuos
                          domésticos, ahora si va realizar trabajos de
                          reparaciones uso de sustancias químicas entonces se
                          debe sumar residuos industriales no peligrosos y
                          residuos peligrosos esos son los aspectos, como
                          incidente mezcla de residuos, disponer en sitios no
                          autorizados, como consecuencia contaminación de
                          suelo.</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 10px">
                        ¿Va a transitar en vehículos propios en faena incluso
                        sectores de concentradora, tranque, mina o rajo y/o área
                        de lixiviación.?
                      </td>
                      <td style="text-align: center">
                        <el-radio disabled v-model="preguntas['4']" label="SI"
                          >SI</el-radio
                        >
                        <el-radio disabled v-model="preguntas['4']" label="NO"
                          >NO</el-radio
                        >
                      </td>
                    </tr>
                    <tr v-if="preguntas['4'] === 'SI'">
                      <td colspan="2" style="padding: 10px">
                        <span style="color: red"
                          >Entonces aplica como aspecto fauna, incidente
                          atropello, muerte de fauna, consecuencia alteración
                          patrimonio cultural, daño o alteración a flora o
                          fauna.</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 10px">
                        ¿Podrían trabajar por concentradora, ripios o tranque?
                      </td>
                      <td style="text-align: center">
                        <el-radio disabled v-model="preguntas['5']" label="SI"
                          >SI</el-radio
                        >
                        <el-radio disabled v-model="preguntas['5']" label="NO"
                          >NO</el-radio
                        >
                      </td>
                    </tr>
                    <tr v-if="preguntas['5'] === 'SI'">
                      <td colspan="2" style="padding: 10px">
                        <span style="color: red"
                          >Entonces aplica aspecto sitios arqueológicos,
                          incidente rogo e elementos arqueológicos, daño a
                          sitios arqueológicos, consecuencia alteración
                          patrimonio cultural</span
                        >
                      </td>
                    </tr>
                  </table>
                </el-collapse-item>
              </el-collapse>
            </div>
          </el-col>

          <el-col :md="24">
            <el-table
              :key="render"
              class="tasksTable"
              :data="tareasInventario"
              v-if="tareasInventario.length > 0"
              style="width: 100%"
              header-cell-class-name="header-cell-class-table-gray-2"
            >
              <el-table-column
                type="index"
                align="center"
                width="50"
                label="N°"
              />
              <el-table-column
                prop="nombre"
                :label="$t('Nombre de la tarea')"
              />
              <el-table-column
                :label="$t('Procedimiento')"
                align="center"
                header-align="center"
                width="180"
              >
                <template slot-scope="props">
                  <el-tag
                    size="small"
                    type="success"
                    v-if="props.row.procedimiento"
                  >
                    Procedimiento ingresado
                  </el-tag>
                  <el-tag
                    v-else
                    size="small"
                    :type="
                      risksRuleValidation(props.row) === true &&
                      (props.row.procedimiento === '' ||
                        !props.row.procedimiento)
                        ? 'danger'
                        : 'info'
                    "
                  >
                    {{
                      risksRuleValidation(props.row) === true &&
                      (props.row.procedimiento === "" ||
                        !props.row.procedimiento)
                        ? "Procedimiento pendiente"
                        : "Procedimiento no requerido"
                    }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="ready"
                :label="$t('Información')"
                align="center"
                header-align="center"
                width="150"
              >
                <template slot-scope="scope">
                  <el-tag class="tag" type="success" v-if="scope.row.riesgos"
                    >{{ scope.row.riesgos.length }} {{ $t("riesgos") }}</el-tag
                  >
                  <el-tag v-else type="warning">{{ $t("0 riesgos") }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                header-align="center"
                width="450"
                :label="$t('Operaciones')"
                v-if="!$store.getters.user.readonly"
              >
                <template slot-scope="scope">
                  <el-button
                    type="info"
                    size="small"
                    @click="editRisks(scope.row)"
                    >{{ $t("Identificar riesgos") }}
                  </el-button>
                  <el-button
                    v-if="
                      ['coordinator', 'contractor_coordinator'].includes(
                        $store.getters.role.role
                      ) || $store.getters.role.admin
                    "
                    type="warning"
                    size="small"
                    @click="copyTasks(scope.row)"
                    >{{ $t("Copiar a otro inventario") }}
                  </el-button>
                  <el-button
                    type="danger"
                    size="small"
                    @click="deleteTask(scope.row)"
                    icon="el-icon-delete"
                  />
                </template>
              </el-table-column>
              <el-table-column
                prop="ready"
                :label="$t('Ordenar')"
                align="center"
                header-align="center"
                width="140"
                v-if="!$store.getters.user.readonly"
              >
                <template slot-scope="scope">
                  <el-button
                    style="font-size: 15px"
                    plain
                    size="mini"
                    type="success"
                    @click="moveUp(scope.$index, scope.row)"
                    icon="el-icon-top"
                  />
                  <el-button
                    style="font-size: 15px"
                    plain
                    size="mini"
                    type="danger"
                    @click="moveDown(scope.$index, scope.row)"
                    icon="el-icon-bottom"
                  />
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-tab-pane>
      <!-- Contrato -->
      <el-tab-pane class="paddingBody" :label="$t('Contrato')">
        <MostrarContrato
          :contract="contract"
          :fatherArea="fatherArea"
          :area="area"
          :workflows="workflows"
          :peopleContract="usersFaena"
        />
      </el-tab-pane>
      <el-tab-pane label="Seguimiento" class="paddingBody">
        <center v-if="loading_seguimiento">
          <br />
          <br />
          <Circle9 style="margin-bottom: 8px"></Circle9>
          <small>Cargando Datos ...</small>
          <br />
          <br />
        </center>
        <el-table
          v-else
          header-cell-class-name="header-cell-class-table-gray"
          :data="seguimiento"
          style="width: 100%"
          height="600"
          empty-text="No se han encontrado datos de seguimiento"
        >
          <el-table-column width="110">
            <template slot-scope="scope">
              <img
                v-if="scope.row.type === 'add'"
                src="../../assets/icons/add.png"
                width="50"
              />
              <img
                v-if="scope.row.type === 'delete'"
                src="../../assets/icons/delete.png"
                width="50"
              />
              <img
                v-if="scope.row.type === 'update'"
                src="../../assets/icons/update.png"
                width="50"
              />
            </template>
          </el-table-column>
          <el-table-column
            width="260"
            prop="user"
            label="Nombre"
          ></el-table-column>
          <el-table-column width="260" label="Fecha">
            <template slot-scope="scope">{{
              scope.row.date | moment("DD/MM/YYYY hh:mm:ss")
            }}</template>
          </el-table-column>
          <el-table-column prop="action" label="Acción"></el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane
        v-if="inventory && inventory.motivos"
        class="paddingBody content"
        :label="$t('Motivos cambios a borrador')"
      >
        <el-table
          :data="inventory.motivos"
          style="width: 100%"
          header-cell-class-name="header-cell-class-table-gray"
        >
          <el-table-column width="400" prop="fecha" label="Fecha">
            <template slot-scope="scope">
              {{ scope.row.fecha | moment("LLLL") }}
            </template>
          </el-table-column>
          <el-table-column prop="motivo" label="Motivo"> </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane
        v-if="inventory"
        @tab-click="clickTab"
        class="paddingBody content"
        :label="$t('Comentarios')"
      >
        <el-button
          v-if="
            !loadingComentarios &&
            !['coordinator', 'contractor_coordinator'].includes(
              $store.getters.role.role
            ) &&
            !$store.getters.user.readonly
          "
          @click="addComentario = true"
          type="primary"
          size="small"
          >Agregar Comentario</el-button
        >
        <center v-if="loadingComentarios">
          <br />
          <br />
          <Circle9 style="margin-bottom: 8px"></Circle9>
          <small>Cargando Datos ...</small>
          <br />
          <br />
        </center>
        <el-table
          v-else
          :data="comentarios"
          style="width: 100%; margin-top: 20px"
          header-cell-class-name="header-cell-class-table-gray"
        >
          <el-table-column prop="nombre" label="Usuario"> </el-table-column>
          <el-table-column prop="rol" label="Rol">
            <template slot-scope="scope">
              {{ reviewerRoles[scope.row.rol] }}
            </template>
          </el-table-column>
          <el-table-column prop="fecha" label="Fecha">
            <template slot-scope="scope">
              {{ getHumanDate(scope.row.fecha) }}
            </template>
          </el-table-column>
          <el-table-column prop="comentario" label="Comentario">
          </el-table-column>
          <el-table-column
            label="Opciones"
            v-if="
              !['coordinator', 'contractor_coordinator'].includes(
                $store.getters.role.role
              ) && !$store.getters.user.readonly
            "
          >
            <template slot-scope="scope">
              <el-button
                v-if="
                  scope.row.id_usuario === $store.getters.user._id ||
                  this.role.admin === true
                "
                @click="deleteComentario(scope.row._id)"
                type="danger"
                size="small"
                >Eliminar</el-button
              >
              <el-button
                v-if="
                  scope.row.id_usuario === $store.getters.user._id ||
                  this.role.admin === true
                "
                @click="openEditComentario(scope.row)"
                type="info"
                size="small"
                >Editar</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title="Listado de inventarios"
      :visible.sync="copyInventoryTask"
      width="80%"
      :before-close="handleClose"
    >
      <el-form
        :inline="true"
        style="margin-top: 15px"
        onsubmit="return false;"
        label-position="left"
      >
        <el-form-item label="Tipo de contrato">
          <el-select
            class="tipoContrato"
            size="small"
            v-model="contractType"
            placeholder="Seleccione tipo"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-left: 15px" label="Búsqueda avanzada">
          <el-input
            :placeholder="$t('Búsqueda por nombre')"
            prefix-icon="el-icon-search"
            v-model="search"
            class="search"
            size="small"
          />
        </el-form-item>
      </el-form>
      <el-alert type="info" show-icon>
        <b>Considerar los siguientes puntos.</b>
        <ol>
          <li>
            Es obligatorio que el inventario destino (donde se va copiar la
            información desde otros inventarios) debe estar en estado Borrador
            (editable).
          </li>
          <li>
            Si el inventario está en estado “No iniciado” no se podrá copiar
            información desde otros inventarios, como se señala en el primer
            punto el inventario debe estar en borrador, para esto debe contar al
            menos con la primera tarea creada de forma manual por el coordinador
            responsable.
          </li>
          <li>
            Esta función también aplica para inventarios que se encuentran
            aprobados y requieren ser actualizados en plataforma, recordar que
            antes de iniciar el proceso de copiado de información desde otros
            inventarios se debe dejar el inventario destino nuevamente en estado
            borrador.
          </li>
        </ol>
      </el-alert>
      <el-table
        v-loading="loading_inv"
        style="margin-top: 15px"
        :data="paginar === false ? inventarios : paginarInventarios()"
        class="inventoryTable"
        :max-height="700"
        :header-cell-style="
          () =>
            'background-color: #242424; color: white; padding: 0px; border-width: 2px;'
        "
      >
        <el-table-column
          :label="$t('Nombre')"
          prop="nombre"
          sortable
        ></el-table-column>
        <el-table-column label="Estado" align="center" width="210">
          <template slot-scope="scope">
            <span
              :class="`safety-tag font_size_22px inventario_estado inventario_estado_${
                JSON.stringify(scope.row.inventario) !== 'null'
                  ? scope.row.inventario.status
                  : 'undefined'
              }`"
              >{{ getStatus(scope.row) }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="Opciones" align="center" width="150">
          <template slot-scope="scope">
            <el-button
              v-if="
                scope.row.inventario &&
                ![1, 2, 4, '1', '2', '4'].includes(scope.row.inventario.status)
              "
              @click="copiarTareaInventario(scope.row)"
              size="small"
              type="warning"
              >Seleccionar</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <br />
      <br />
      <center>
        <el-pagination
          :current-page="page"
          @prev-click="backPage"
          @next-click="nextPage"
          @current-change="currentPage"
          :page-size="5"
          layout="prev, pager, next"
          :total="totalPage"
        />
      </center>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cancelar</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Agregar Comentario"
      :visible.sync="addComentario"
      width="30%"
      :before-close="handleClose"
    >
      <el-form>
        <el-form-item label="Ingrese su comentario">
          <el-input
            type="textarea"
            :rows="3"
            :placeholder="$t('Ingrese sus comentarios')"
            v-model="comentario.comentario"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cancelar</el-button>
        <el-button type="primary" @click="addComentarioBD">Confirmar</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Editar Comentario"
      :visible.sync="editComentario"
      width="30%"
      :before-close="handleClose"
    >
      <el-form>
        <el-form-item label="Ingrese su comentario">
          <el-input
            type="textarea"
            :rows="3"
            :placeholder="$t('Ingrese sus comentarios')"
            v-model="comentario.comentario"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cancelar</el-button>
        <el-button type="primary" @click="actualizarComentario"
          >Confirmar</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="Inventario sin riesgos de medioambiente"
      :visible.sync="dialogTest"
      width="53%"
      :before-close="handleClose"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div style="padding-top: 20px">
        <table style="width: 100%" border="1px" cellspacing="0px">
          <tr>
            <td style="padding: 10px">¿Ustedes conducen?</td>
            <td style="text-align: center">
              <el-radio v-model="preguntas['1']" label="SI">SI</el-radio>
              <el-radio v-model="preguntas['1']" label="NO">NO</el-radio>
            </td>
          </tr>
          <tr v-if="preguntas['1'] === 'SI'">
            <td colspan="2" style="padding: 10px">
              <span style="color: red">
                Entonces su aspecto es la conducción o la camioneta, el
                incidente falla de sistema hidráulico o rotura de estanque
                combustible o aumento en gases de combustión, como consecuencia
                contaminación de suelo, alteración de la calidad del aire.</span
              >
            </td>
          </tr>
          <tr>
            <td style="padding: 10px">
              ¿Usted tiene instalación de faena o estará en oficinas?
            </td>
            <td style="text-align: center">
              <el-radio v-model="preguntas['2']" label="SI">SI</el-radio>
              <el-radio v-model="preguntas['2']" label="NO">NO</el-radio>
            </td>
          </tr>
          <tr v-if="preguntas['2'] === 'SI'">
            <td colspan="2" style="padding: 10px">
              <span style="color: red"
                >Entonces su aspecto el trabajo administrativo, incidente mal
                uso, pérdidas o derroche de uso de agua o recurso hídrico,
                consecuencia agotamiento de recurso natural / incidente mal uso
                de energía eléctrica, consecuencia agotamiento de recurso,
                aumento gases efecto invernadero.</span
              >
            </td>
          </tr>
          <tr>
            <td style="padding: 10px">¿Usted comerá algo tomará agua?</td>
            <td style="text-align: center">
              <el-radio v-model="preguntas['3']" label="SI">SI</el-radio>
              <el-radio v-model="preguntas['3']" label="NO">NO</el-radio>
            </td>
          </tr>
          <tr v-if="preguntas['3'] === 'SI'">
            <td colspan="2" style="padding: 10px">
              <span style="color: red"
                >Entonces sí o sí va a tener generación de residuos domésticos,
                ahora si va realizar trabajos de reparaciones uso de sustancias
                químicas entonces se debe sumar residuos industriales no
                peligrosos y residuos peligrosos esos son los aspectos, como
                incidente mezcla de residuos, disponer en sitios no autorizados,
                como consecuencia contaminación de suelo.</span
              >
            </td>
          </tr>
          <tr>
            <td style="padding: 10px">
              ¿Va a transitar en vehículos propios en faena incluso sectores de
              concentradora, tranque, mina o rajo y/o área de lixiviación.?
            </td>
            <td style="text-align: center">
              <el-radio v-model="preguntas['4']" label="SI">SI</el-radio>
              <el-radio v-model="preguntas['4']" label="NO">NO</el-radio>
            </td>
          </tr>
          <tr v-if="preguntas['4'] === 'SI'">
            <td colspan="2" style="padding: 10px">
              <span style="color: red"
                >Entonces aplica como aspecto fauna, incidente atropello, muerte
                de fauna, consecuencia alteración patrimonio cultural, daño o
                alteración a flora o fauna.</span
              >
            </td>
          </tr>
          <tr>
            <td style="padding: 10px">
              ¿Podrían trabajar por concentradora, ripios o tranque?
            </td>
            <td style="text-align: center">
              <el-radio v-model="preguntas['5']" label="SI">SI</el-radio>
              <el-radio v-model="preguntas['5']" label="NO">NO</el-radio>
            </td>
          </tr>
          <tr v-if="preguntas['5'] === 'SI'">
            <td colspan="2" style="padding: 10px">
              <span style="color: red"
                >Entonces aplica aspecto sitios arqueológicos, incidente rogo e
                elementos arqueológicos, daño a sitios arqueológicos,
                consecuencia alteración patrimonio cultural</span
              >
            </td>
          </tr>
        </table>

        <el-alert
          v-if="validAlert()"
          style="margin-top: 20px"
          show-icon
          title="Para continuar con el envío del inventario a revisión primero debe crear el o los riesgos ambientales requeridos en el formulario."
          type="info"
        >
        </el-alert>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :disabled="validContinueEdit()"
          @click="handleClose"
          >Continuar editando</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="Listado de riesgos sin impactos"
      :visible.sync="dialogSinImp"
      width="53%"
      :before-close="handleClose"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <el-alert
        style="margin-top: 20px"
        show-icon
        title="Los siguientes riesgos se encuentran sin impactos asociados, para continuar con el proceso de revisión debe completarlos."
        type="warning"
      >
      </el-alert>
      <el-table :data="riesgos_sin_imp" style="width: 100%; margin-top: 20px">
        <el-table-column prop="tarea" label="Tarea"> </el-table-column>
        <el-table-column prop="riesgo" label="Riesgo"> </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="dialogSinImp = false"
          >Cancelar</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import uuid from "uuid/v4";
import moment from "moment";
import { Circle9 } from "vue-loading-spinner";
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import inventoryRequirements from "@/mixins/inventoryRequirements";
import MostrarContrato from "@/components/MostrarContrato.vue";

export default {
  mixins: [inventoryRequirements],
  components: {
    MostrarContrato,
    Circle9,
  },
  data() {
    return {
      loading_ds44: false,
      inventario_estado: {
        0: "Borrador",
        1: "En revisión",
        2: "Aprobado",
        3: "Importado Borrador",
        4: "Validación de Medioambiente",
      },
      loading_inv: false,
      search: "",
      tarea: {},
      copyInventoryTask: false,
      reviewerRoles: {
        admin: "Administrador de Plataforma",
        health: "Especialista de Salud",
        safety: "Especialista de Seguridad",
        environment: "Especialista de Medioambiente",
        contractor_hse: "HSE Contratista",
        contract_owner: "Dueño de Contrato",
        administrator: "Administrador de Contrato",
        hse: "HSE",
        owner: "Dueño de Contrato",
        risk: "Especialista de Riesgo",
        manager: "Gerente",
        super: "Superintendente",
        general_manager: "Gerente General",
      },
      id_comentario: null,
      comentario: {
        comentario: "",
      },
      addComentario: false,
      editComentario: false,
      comentarios: [],
      dialogSinImp: false,
      riesgos_sin_imp: [],
      preguntas: {
        1: "",
        2: "",
        3: "",
        4: "",
        5: "",
      },
      dialogTest: false,
      seguimiento: [],
      loading_seguimiento: false,
      render: 0,
      searchUser: false,
      isLoading: false,
      task: "",
      taskEditId: null,
      renameTask: "",
      saveLoading: false,
      isEdit: false,
      loadingComentarios: false,
      inventarios: [],
      page: 1,
      totalPage: 0,
      paginar: false,
      vencido: false,
      contractType: "Contratista",
      options: [
        {
          value: "Contratista",
          label: "Contratista",
        },
      ],
      procedureRules: {
        "5a6f78337b772dcfe68241d5": { mfl: 4, rrr: 10 },
        default: { mfl: 3, rrr: 90 },
      },
      rule: { mfl: 3, rrr: 10 },
    };
  },
  computed: {
    ...mapGetters({
      role: "role",
      inventario: "inventario",
    }),

    contractId() {
      return this.contract && (this.contract._id || this.contract.id);
    },

    tareasInventario() {
      if (!this.inventario.tareas || this.inventario.tareas == null) {
        return [];
      }
      return this.inventario.tareas;
    },
    haveEnvironmentalRisks() {
      let have = false;
      if (this.inventario && this.inventario.tareas) {
        this.inventario.tareas.forEach((tarea) => {
          if (tarea.riesgos) {
            tarea.riesgos.forEach((riesgo) => {
              if (
                riesgo.tipo &&
                riesgo.tipo.toLowerCase() === "medioambiente"
              ) {
                have = true;
              }
            });
          }
        });
      }
      return have;
    },
  },
  async created() {
    if (
      this.$store.getters.role.admin === true ||
      ![
        "contractor_coordinator",
        "contractor_hse",
        "administrator",
        "contract_owner",
      ].includes(this.$store.getters.role.role)
    ) {
      this.options.push({
        value: "Propio",
        label: "Propio",
      });
    }
    await this.setProcedureRule();
  },
  watch: {
    step_percentage(newVal, oldVal) {
      if (newVal === 100) {
        setTimeout(() => (this.hidden = true), 1500);
      }
    },
    search() {
      this.debounceInputSearch();
    },
    contractType() {
      this.page = 1;
      this.listadoInventarios(this.page, this.search);
    },
    inventario: {
      handler() {
        this.$store.dispatch(
          "setStatus",
          this.inventario.wasApproved === true &&
            [0, 1, "0", "1"].includes(parseInt(this.inventario.status))
            ? `${this.inventario.status}wasApproved`
            : this.inventario.status
        );
        this.checkImpactDescription();
      },
    },
    contract: {
      handler() {
        if (this.contract && this.contract.nombre) {
          this.setSubTitle(`${this.contract.nombre}`);
        }
      },
    },
  },
  methods: {
    ...mapActions(["setSubTitle", "setInventario"]),
    async setProcedureRule() {
      this.rule =
        this.procedureRules[this.$store.getters.role.faena_id] ||
        this.procedureRules.default;
    },
    risksRuleValidation(tarea) {
      var requiere = false;
      if (tarea.riesgos && tarea.riesgos.length > 0) {
        tarea.riesgos.forEach((r) => {
          if (r.impactos.length > 0) {
            const { mfl } = r.impactos[0];
            const rrr =
              r.impactos[0].factor_severidad *
              r.impactos[0].factor_probabilidad;
            if (mfl >= this.rule.mfl || rrr >= this.rule.rrr) {
              requiere = true;
            }
          }
        });
      }
      return requiere;
    },
    checkImpactDescription() {
      /* ELIMINAR EN FUTURO SOLO ES POPPUP TEMPORAL */
      var corregir = [];
      if (this.inventario.tareas) {
        this.inventario.tareas.forEach((t) => {
          if (t.riesgos) {
            t.riesgos.forEach((r) => {
              if (r.nombre && r.tipo) {
                if (
                  r.nombre.toLowerCase() === "biodiversidad" &&
                  ["medioambiente", "medioambiental"].includes(
                    r.tipo.toLowerCase().replace(/ /g, "")
                  )
                ) {
                  corregir.push(t.nombre);
                }
              }
            });
          }
        });
      }
      if (corregir.length > 0) {
        var lista = "";
        corregir.forEach((c) => {
          lista = lista + `<li>${c}</li>`;
        });
        this.$alert(
          `
          Las siguientes tareas contienen el riesgo medioambiental Biodiversidad,
          este debe ser cambiado por Biodiversidad - Flora o Biodiversidad - Fauna. <ul>${lista}</ul>`,
          "Información importante",
          {
            dangerouslyUseHTMLString: true,
          }
        );
      }
    },
    async getInventory() {
      await this.$store.dispatch("getInventory", this.contract).then(() => {});
    },
    debounceInputSearch: _.debounce(function () {
      this.page = 1;
      this.listadoInventarios(this.page, this.search);
    }, 1200),
    copiarTareaInventario(row) {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      this.$confirm(
        `Estimado usuario coordinador, por favor, considere el impacto que los diferentes escenarios, pueden generar en la evaluación del riesgo. ¿Deseas Continuar?`,
        "Advertencia",
        {
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      )
        .then(async () => {
          this.tarea.riesgos.forEach((r) => {
            if (r.custom === true) {
              r._id = uuid();
              r.status = 0;
              r.status_step = 0;
              r.status_by = null;
              r.status_position = null;
              r.status_message = null;
              r.status_step_approve = [];
              r.status_history = null;
              r.status_updated_at = null;
            }
          });
          await axios.post(
            `/inventarios/copiarTareaInventario`,
            {
              id_inventory: row.inventario._id,
              tarea: this.tarea,
            },
            config
          );
          this.$notify({
            duration: 3000,
            title: "Atención",
            message: "Tarea copiada exitosamente",
            type: "success",
          });
          this.getInventory();
          this.handleClose();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getStatus(row) {
      if (!row.inventario) {
        return "No iniciado";
      }
      if (row.inventario.wasApproved === true) {
        if (row.inventario.status === 1 || row.inventario.status === 0) {
          return "Aprobado en actualización";
        }
      }
      return this.inventario_estado[row.inventario.status];
    },
    paginarInventarios() {
      return this.inventarios.slice((this.page - 1) * 5, this.page * 5);
    },
    currentPage(page) {
      this.page = page;
      this.listadoInventarios(page, this.search);
    },
    nextPage(page) {
      this.page = page;
      this.listadoInventarios(page, this.search);
    },
    backPage(page) {
      this.page = page;
      this.listadoInventarios(page, this.search);
    },
    listadoInventarios(page, search) {
      const self = this;
      this.loading_inv = true;
      let url = `/contratos/byUFAER?vencido=${this.vencido}&userId=${this.$store.getters.user._id}&faenaId=${this.$store.getters.role.faena_id}`;
      url = this.$store.getters.role.admin
        ? `${url}&role=admin`
        : this.$store.getters.role.area_id === "GeneralAreasRoles"
        ? `${url}&role=allAreas`
        : `${url}&role=${this.$store.getters.role.role}`;
      url += `&actualRole=${this.$store.getters.role.role}`;
      if (this.$store.getters.role.area_id) {
        url = `${url}&areaId=${this.$store.getters.role.area_id}`;
      }
      if (this.$store.getters.role.empresa_id) {
        url = `${url}&empresaId=${this.$store.getters.role.empresa_id}`;
      }
      axios
        .get(
          `${url}&page=${page}&tipo=${this.contractType}&search=${
            search === "" ? undefined : search
          }`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then((response) => {
          self.inventarios = response.data.contratos.results;
          self.totalPage = response.data.contratos.total;
          self.paginar = response.data.contratos.paginar;
          self.loading_inv = false;
        });
    },
    copyTasks(tarea) {
      this.tarea = JSON.parse(JSON.stringify(tarea));
      if (this.tarea["id"]) {
        this.tarea["id"] = this.generateUUID();
      } else {
        this.tarea["_id"] = this.generateUUID();
      }
      this.listadoInventarios(1, "");
      this.copyInventoryTask = true;
    },
    generateUUID() {
      var d = new Date().getTime();
      var uuid = "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    },
    async moveUp(index, task) {
      this.$store.dispatch("upTask", index);
      this.render++;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      var resp = await axios.post(
        `/inventarios/setPositionTask`,
        {
          id_inventario: this.inventario._id,
          indice: index === 0 ? 0 : index - 1,
          tarea: task,
          id_tarea: task.id || task._id,
        },
        config
      );

      if (resp.data.status === true) {
        this.$notify({
          duration: 3000,
          title: "Atención",
          message: resp.data.mensaje,
          type: "success",
        });
      }
      /* this.saveInventory(); */
    },
    async moveDown(index, task) {
      this.$store.dispatch("downTask", index);
      this.render++;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      var resp = await axios.post(
        `/inventarios/setPositionTask`,
        {
          id_inventario: this.inventario._id,
          indice: index + 1,
          tarea: task,
          id_tarea: task.id || task._id,
        },
        config
      );

      if (resp.data.status === true) {
        this.$notify({
          duration: 3000,
          title: "Atención",
          message: resp.data.mensaje,
          type: "success",
        });
      }
      /* this.saveInventory(); */
    },
    openEditComentario(comentario) {
      this.id_comentario = comentario._id;
      this.comentario.comentario = comentario.comentario;
      this.editComentario = true;
    },
    deleteComentario(_id) {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      this.$confirm(
        "Estás a punto de eliminar un comentario. ¿Deseas Continuar?",
        "Advertencia",
        {
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      )
        .then(async () => {
          await axios.post(
            `/inventarios/deleteComentarios`,
            {
              _id: _id,
            },
            config
          );
          this.getComentarios();
        })
        .catch(() => {});
    },
    getHumanDate(date) {
      return moment(date).format("DD MMMM YYYY HH:mm");
    },
    async actualizarComentario() {
      this.$confirm(
        "Estás a punto de actualizar un comentario. ¿Deseas Continuar?",
        "Advertencia",
        {
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      )
        .then(async () => {
          const config = {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          };
          if (this.comentario.comentario === "") {
            this.$notify({
              duration: 3000,
              title: "Atención",
              message: "Para continuar debes completar todos los campos",
              type: "Warning",
            });
          } else {
            await axios.post(
              `/inventarios/updateComentario`,
              {
                _id: this.id_comentario,
                comentario: this.comentario.comentario,
              },
              config
            );
            this.getComentarios();
            this.handleClose();
          }
        })
        .catch(() => {});
    },
    async addComentarioBD() {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      if (this.comentario.comentario === "") {
        this.$notify({
          duration: 3000,
          title: "Atención",
          message: "Para continuar debes completar todos los campos",
          type: "Warning",
        });
      } else {
        await axios.post(
          `/inventarios/addComentario`,
          {
            id_usuario: this.$store.getters.user._id,
            rol: this.$store.getters.role.role,
            id_inventario: this.inventario._id,
            nombre: `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`,
            comentario: this.comentario.comentario,
            fecha: new Date(),
            leido: false,
          },
          config
        );
        this.getComentarios();
        this.handleClose();
      }
    },
    async getComentarios() {
      this.loadingComentarios = true;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      let response = await axios.post(
        `/inventarios/getAllComentarios`,
        {
          id_inventario: this.inventory._id,
        },
        config
      );
      this.comentarios = response.data;
      this.loadingComentarios = false;
    },
    validContinueEdit() {
      var success = false;
      for (const key in this.preguntas) {
        if (this.preguntas[key] === "") {
          success = true;
        }
      }
      return success;
    },
    validContinue() {
      var success = true;
      for (const key in this.preguntas) {
        if (this.preguntas[key] !== "NO") {
          success = false;
        }
      }
      return success;
    },
    validAlert() {
      var valid = [];
      for (const key in this.preguntas) {
        if (this.preguntas[key] !== "") {
          valid.push(this.preguntas[key]);
        }
      }
      if (valid.length === 5 && valid.includes("SI")) {
        return true;
      } else {
        return false;
      }
    },
    validCheckTarea(tarea_name) {
      if (this.inventario && tarea_name && this.inventario.tareas) {
        for (let i = 0; i < this.inventario.tareas.length; i++) {
          const element = this.inventario.tareas[i];
          if (element && element.nombre) {
            if (
              this.eliminarDiacriticos(
                element.nombre.replace(/ /g, "").toLowerCase()
              ) ===
              this.eliminarDiacriticos(
                tarea_name.replace(/ /g, "").toLowerCase()
              )
            ) {
              return true;
              break;
            }
          }
        }
      }
      return false;
    },
    clickTab(tab) {
      if (tab.label === "Seguimiento") {
        this.getSeguimiento(this.inventory._id);
      }
      if (tab.label === "Comentarios") {
        this.getComentarios();
      }
    },
    getSeguimiento(id) {
      this.loading_seguimiento = true;
      const self = this;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      axios
        .get(`/inventarios/getSeguimiento/${id}`, config)
        .then((response) => {
          self.seguimiento = response.data;
          self.loading_seguimiento = false;
        });
    },
    canSendToApproval() {
      if (
        this.tareasInventario.length > 0 &&
        this.role &&
        (this.role.admin ||
          ["contractor_coordinator", "coordinator"].includes(this.role.role)) &&
        (!this.inventario.status ||
          [0, 3].includes(parseInt(this.inventario.status))) &&
        this.inventario.tareas &&
        this.inventario.tareas.length > 0
      ) {
        return true;
      }
      return false;
    },
    handleClose() {
      this.search = "";
      this.copyInventoryTask = false;
      this.dialogTest = false;
      this.isEdit = false;
      this.task = "";
      this.dialogSinImp = false;
      this.comentario = {
        comentario: "",
      };
      this.id_comentario = null;
      this.editComentario = false;
      this.addComentario = false;
    },
    saveInventory() {
      this.saveLoading = true;
      this.$store.dispatch("createOrUpdateDraft").then((response) => {
        this.saveLoading = false;
        if (response.success) {
          this.$notify({
            duration: 3000,
            title: "Atención",
            message: "Cambios guardados exitosamente",
            type: "success",
          });
        } else {
          this.$alert(response.message, this.$t("Error"), {
            type: "error",
          });
        }
      });
    },
    closeDialogTask() {
      this.renameTask = "";
      this.taskEditId = null;
    },
    editFormTask(task) {
      this.renameTask = task.nombre;
      this.taskEditId = task.id || task._id;
    },
    handleAddTask() {
      this.loadingAllDataRequired = true;
      if (!this.inventario.tareas) {
        this.$store.dispatch("addTask", this.task).then(async (res) => {
          this.editRisks(res);
          this.saveInventory();
          this.loadingAllDataRequired = false;
        });
      } else {
        this.$store.dispatch("addTask", this.task).then(async (res) => {
          const config = {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          };
          var resp = await axios.post(
            `/inventarios/addTaskInv`,
            {
              id_inventario: this.inventario._id,
              tarea: res,
            },
            config
          );

          if (resp.data.status === true) {
            this.editRisks(res);
            this.$notify({
              duration: 3000,
              title: "Atención",
              message: "Tarea agregada exitosamente",
              type: "success",
            });
            this.loadingAllDataRequired = false;
          } else {
            this.$notify({
              duration: 3000,
              title: "Atención",
              message: "Tarea no pudo ser agregada",
              type: "warning",
            });
            this.loadingAllDataRequired = false;
          }
        });
      }

      //this.saveInventory();
    },
    editRisks(task) {
      this.$store.dispatch("selectTask", task).then(() => {
        this.$router.push({ name: "firstStep" });
      });
    },
    deleteTask(task) {
      this.$confirm(
        this.$t(
          "Esto borrará la tareas y todos sus riesgos. ¿Está seguro que desea continuar?"
        ),
        this.$t("Atención"),
        {
          type: "warning",
        }
      ).then(() => {
        this.$store.dispatch("deleteTask", task).then(async () => {
          const config = {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          };
          var resp = await axios.post(
            `/inventarios/deleteTaskInv`,
            {
              id_inventario: this.inventario._id,
              id_tarea: task.id || task._id,
            },
            config
          );

          if (resp.data.status === true) {
            this.$notify({
              duration: 3000,
              title: "Atención",
              message: "Tarea eliminada exitosamente",
              type: "success",
            });
            /* this.$router.push({ name: `/inventario/${contract._id}/editar` }); */
          } else {
            this.$notify({
              duration: 3000,
              title: "Atención",
              message: "Tarea no pudo ser eliminada",
              type: "warning",
            });
          }
          /* this.$store.dispatch("createOrUpdateDraft").then((response) => {
            if (response.success) {
              this.$notify.info({
                duration: 3000,
                title: "Atención",
                message: `${this.$t("Tarea")} "${task.nombre}" ${this.$t(
                  "eliminada exitosamente"
                )}`,
              });
              this.saveInventory();
              this.$router.push({ name: `/inventario/${contract._id}/editar` });
            } else {
              this.$alert(response.message, this.$t("Atención"), {
                type: "error",
              });
            }
          }); */
        });
      });
    },
    username() {
      return `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`;
    },
    verificarMA() {
      this.riesgos_sin_imp = [];
      var continuar = true;
      for (let i = 0; i < this.inventario.tareas.length; i++) {
        if (
          !this.inventario.tareas[i]["riesgos"] ||
          this.inventario.tareas[i]["riesgos"].length === 0
        ) {
          this.$alert(
            `La tarea número ${i + 1} no tiene ningún riesgo asignado`,
            "Información importante",
            {
              confirmButtonText: "Aceptar",
              type: "warning",
            }
          );
          return;
        }
        if (
          this.risksRuleValidation(this.inventario.tareas[i]) === true &&
          (this.inventario.tareas[i]["procedimiento"] === "" ||
            !this.inventario.tareas[i]["procedimiento"])
        ) {
          this.$alert(
            `La tarea "${this.inventario.tareas[i]["nombre"]}" debe llevar procedimiento y no lo tiene asignado.`,
            this.$t("Atención"),
            {
              type: "warning",
            }
          );
          continuar = false;
          return;
        }
        if (
          this.inventario.tareas[i]["riesgos"] &&
          this.inventario.tareas[i]["riesgos"].length > 0
        ) {
          for (
            let x = 0;
            x < this.inventario.tareas[i]["riesgos"].length;
            x++
          ) {
            if (
              !this.inventario.tareas[i]["riesgos"][x].impactos ||
              this.inventario.tareas[i]["riesgos"][x].impactos.length === 0
            ) {
              continuar = false;
              this.riesgos_sin_imp.push({
                tarea: this.inventario.tareas[i].nombre,
                riesgo: this.inventario.tareas[i]["riesgos"][x].nombre,
              });
            }
          }
        }
      }
      if (continuar === true) {
        this.sendToReview();
      } else {
        this.dialogSinImp = true;
      }
    },
    eliminarDiacriticos(texto) {
      return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },
    async sendToReview() {
      // Verificar inventario tiene riesgos mediombientales
      if (!this.haveEnvironmentalRisks) {
        this.$alert(
          "Su inventario no tiene riesgos medioambientales, para continuar con el proceso de revisión debe incorporar los riesgos ambientales en su inventario de riesgos",
          "Inventario sin riesgos medioambientales",
          {
            confirmButtonText: "Aceptar",
            callback: (action) => {
              if (
                this.$store.getters.role.faena_id === "5a6f78417b772dcfe68241e5"
              ) {
                this.dialogTest = true;
              }
              this.isLoading = false;
            },
          }
        );
      } else {
        this.isLoading = true;
        // Aviso no es posible modificar
        const send = await this.$confirm(
          this.$t(
            "Una vez que se envíe este inventario a revisión no será posible realizar modificaciones. ¿Seguro que desea continuar?"
          ),
          this.$t("Atención"),
          {
            confirmButtonText: "Enviar a Revisión",
            cancelButtonText: "Cancelar",
          }
        )
          .then(() => true)
          .catch(() => {
            this.isLoading = false;
          });

        if (send) {
          // Revisar que el inventario esté completo
          let isReady = true;
          let onlyStandardized = true;
          let inventoryApproved = true;
          this.inventario.tareas.forEach((tarea) => {
            const tId = tarea.id || tarea._id;
            if (!tarea.riesgos || tarea.riesgos.length === 0) {
              this.$alert("Iventario sin riesgos", "Información", {
                confirmButtonText: "Aceptar",
                type: "warning",
              });
              isReady = false;
              return;
            }

            tarea.riesgos.forEach((riesgo) => {
              if (riesgo.custom === true && riesgo.status !== 1) {
                inventoryApproved = false;
              }
              // status 2 esta aprobado
              if (riesgo.custom && !["2", 2].includes(riesgo.status)) {
                onlyStandardized = false;
                if (!this.isRiskReady(riesgo, tarea)) {
                  isReady = false;
                }
              }
            });
          });

          // Si el inventario no está completo alertar
          if (!isReady) {
            this.isLoading = false;
            return;
          }

          // Definir estado del inventario
          // 0: Borrador, 1: En Revisión, 2: Aprobado, 3: Importado, 4: Validación Medioambiente
          let status = 1;
          if (onlyStandardized) {
            status = 2;
          } else if (inventoryApproved) {
            status = 2;
          }

          // Set Inventario
          const inventario = Object.assign({}, this.inventario, {
            status,
            created_at: this.$store.getters.created_at || new Date(),
          });

          // Registrar cambios en BD
          this.$store.dispatch("setInventario", inventario).then(() => {
            this.$store.dispatch("saveInventario").then(async (response) => {
              // actualizar el contrato en el lado cliente
              const { userContracts } = this.$store.getters;
              const contractToUpdate = userContracts.find(
                (c) => c._id === this.contract._id
              );
              if (contractToUpdate) {
                const invToUp = { ...contractToUpdate.inventario };
                invToUp.status = status;
                this.$store.dispatch("contractAssign", {
                  obj: contractToUpdate,
                  val: { inventario: invToUp },
                });
              } // if

              this.isLoading = false;
              if (response.status) {
                if (onlyStandardized) {
                  this.$alert(
                    this.$t("Inventario enviado y aprobado exitosamente"),
                    this.$t("Atención"),
                    {
                      type: "success",
                    }
                  );
                  const config = {
                    headers: {
                      Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                  };
                  var self = this;
                  axios
                    .post(
                      "/inventarios/uptadeHistoryInventory",
                      {
                        id_inventory: self.inventario._id,
                        action: `El estado del inventario ${self.contract.nombre} ha sido actualizado a aprobado.`,
                        user: self.username(),
                        date: new Date(),
                        type: "update",
                      },
                      config
                    )
                    .then((response) => {});
                } else {
                  this.$alert(
                    this.$t("Inventario enviado a revisión exitosamente"),
                    this.$t("Atención"),
                    {
                      type: "success",
                    }
                  );
                  const config = {
                    headers: {
                      Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                  };
                  var self = this;
                  axios
                    .post(
                      "/inventarios/uptadeHistoryInventory",
                      {
                        id_inventory: self.inventario._id,
                        action: `El estado del inventario ${self.contract.nombre} ha sido actualizado a revisión.`,
                        user: self.username(),
                        date: new Date(),
                        type: "update",
                      },
                      config
                    )
                    .then((response) => {});
                }

                // Redireccón a seleccón de inventarios
                this.$router.push({ name: "inventorySelectPage" });
              } else {
                this.$alert(response.message, "Atención", {
                  type: "error",
                });
              }
            });
          });
          this.isLoading = true;
        }
      }
    },
    getMayorImpacto(risk) {
      let mfl = 0;
      let rrr;
      let mayorImpacto;

      if (risk.impactos) {
        risk.impactos.forEach((impacto) => {
          if (impacto.mfl > mfl) {
            ({ mfl } = impacto);
            rrr =
              (impacto.factor_severidad *
                10 *
                (impacto.factor_probabilidad * 10)) /
              (10 * 10);
            mayorImpacto = impacto;
          }
        });
      }

      return {
        impacto: mayorImpacto,
        mfl,
        rrr,
      };
    },
    isRiskReady(risk, tarea) {
      let isReady = true;
      if (!risk.causas || risk.causas.length === 0) {
        this.$alert(
          `<b>Riesgo</b>: ${risk.nombre} <br> <b>Tarea</b>: ${tarea.nombre} <br> <b>Detalle</b>: Riesgo sin causas`,
          "Advertencia",
          {
            confirmButtonText: "Aceptar",
            dangerouslyUseHTMLString: true,
          }
        );
        return false;
      }
      if (!risk.impactos || risk.impactos.length === 0) {
        this.$alert(
          `<b>Riesgo</b>: ${risk.nombre} <br> <b>Tarea</b>: ${tarea.nombre} <br> <b>Detalle</b>: Riesgo sin impactos`,
          "Advertencia",
          {
            confirmButtonText: "Aceptar",
            dangerouslyUseHTMLString: true,
          }
        );
        return false;
      }
      risk.causas.forEach((causa) => {
        if (
          !causa.controles_preventivos ||
          causa.controles_preventivos.length === 0
        ) {
          this.$alert(
            `<b>Riesgo</b>: ${risk.nombre} <br> <b>Tarea</b>: ${tarea.nombre} <br> <b>Detalle</b>: Riesgo sin controles preventivos`,
            "Advertencia",
            {
              confirmButtonText: "Aceptar",
              dangerouslyUseHTMLString: true,
            }
          );
          isReady = false;
        }
      });
      if (!isReady) {
        return false;
      }

      risk.impactos.forEach((impacto) => {
        if (
          !impacto.controles_mitigadores ||
          impacto.controles_mitigadores.length === 0
        ) {
          this.$alert(
            `<b>Riesgo</b>: ${risk.nombre} <br> <b>Tarea</b>: ${tarea.nombre} <br> <b>Detalle</b>: Riesgo sin controles mitigadores`,
            "Advertencia",
            {
              confirmButtonText: "Aceptar",
              dangerouslyUseHTMLString: true,
            }
          );

          isReady = false;
        }
      });
      if (!isReady) {
        return false;
      }
      return true;
    },
  }, // methods
};
</script>

<style scoped>
.tasksTable {
  margin-top: 20px;
  font-size: 13px;
  /* max-height: 70vh;
  overflow: auto; */
}

.widthinputTask {
  width: 95%;
  margin-right: 5px;
}

.tag {
  margin-right: 10px;
}

.content {
  min-height: 50vh;
}

.img_pdf {
  margin-left: 10px;
  height: 30px;
  margin-bottom: 5px;
}

.img_pdf2 {
  height: 30px;
  vertical-align: middle;
  margin-left: 10px;
}

.intermitente {
  box-shadow: 0px 0px 20px;
  animation: infinite resplandorAnimation 2s;
}

@keyframes resplandorAnimation {
  0%,
  100% {
    box-shadow: 0px 0px 20px #ed7d31;
  }

  50% {
    box-shadow: 0px 0px 0px #ed7d31;
  }
}

.inventario_estado_vencido {
  background-color: #b84858;
}

.inventario_estado_undefined {
  background-color: red;
}

.inventario_estado_0 {
  background-color: grey;
}

.inventario_estado_1 {
  background-color: #e4d306;
  color: black;
}

.inventario_estado_2 {
  background-color: #6bc45b;
}

.inventario_estado_3 {
  background-color: orange;
}

.inventario_estado_4 {
  background-color: #e4d306;
}
</style>
